export const aftcabinImageOptions = {
  legacy: true,
  prefix: 'X4_9_Interior',
  angle: 'aftcabin',
  staticOptions: {
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    BeautyBox: 1,
    Pouffes: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    Backrest: 1,
    TableBox: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/aftcabin.js